import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import styles from './MobileAppPopup.module.css';

function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod|android/.test(userAgent);
}

export default function MobileAppPopup() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isMobileDevice()) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
  };

  const handleDownload = () => {
    window.open('https://apps.apple.com/us/app/peapil-health/id6748030177', '_blank');
    handleDismiss();
  };

  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <button className={styles.closeButton} onClick={handleDismiss} aria-label="Close">
          <X size={24} />
        </button>

        <div className={styles.content}>
          <img src="/peapil-logo.png" alt="Peapil Health" className={styles.logo} />
          
          <h2 className={styles.title}>Get the Peapil Health App</h2>
          
          <p className={styles.description}>
            For the best experience, download our mobile app.
          </p>

          <button className={styles.downloadButton} onClick={handleDownload}>
            Download App
          </button>
        </div>
      </div>
    </div>
  );
}
